import * as React from "react";
import DetailPageHeaderMenu from "../../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import {
  BodyText,
  DetailInnerWrapper,
  DetailLayoutWrapper,
  DetailPageBox,
  DetailPageBoxFlexWrapper,
  InnerBox,
} from "../../../components/sharedStyles";

import { IntegrationCompaniesWrapper } from "../../../components/Layout/Accounts/styles";

import INTEGRATIONS from "../integrationsList";
import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  PrimaryButton,
  TextButton,
} from "../../../components/Forms/Base/Buttons";

import { buildQueryString, useFrequentPermissions } from "../../../store/base";

import CompanyTable from "../../../components/Tables/ConfigCenter/Companies/FullTable";
import companyListDefs from "../../../components/Tables/ConfigCenter/Companies/listDefs";

import OverlaySpinner from "../../../components/Loaders/OverlaySpinner";
import StandardModal from "../../../components/Modals/StandardModal";

import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";

import {
  constants as companyConstants,
  useCompanyPagination,
  useFilteredCompanies,
  performFilter as performCompanyFilter,
} from "../../../store/companies";

import KivraIntegrationForm from "../../../components/Billecta/Integrations/KivraIntegrationForm";

import { useDispatch, useSelector } from "react-redux";
import { bulkGetIntegrationSettings } from "../../../store/billectaIntegrations/store/actions";

export default function KivraIntegration() {
  const current = INTEGRATIONS.find((i) => i.title === "Kivra");
  const [pickCompaniesOpen, setPickCompaniesOpen] = React.useState(false);
  const [kivraOpen, setKivraOpen] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const [addCompaniesLoading, setAddCompaniesLoading] = React.useState(false);
  const { hasBillectaViewPermission } = useFrequentPermissions();
  const integrationName = "Kivra";
  const dispatch = useDispatch();
  const [companies, companiesLoading] = useFilteredCompanies(
    buildQueryString({ billecta_id__isnull: false })
  );

  const withCompanyInvoicingQuery = {
    billecta_id__isnull: false,
  };

  const goToWebsite = () => {
    if (!current.visitUrl) return;
    window.open(current.visitUrl, "_blank").focus();
  };

  // const checkRowHighlighted = (row) => {
  //   const { original } = row;
  //   const match = selectedCompanies?.find((s) => s.id === original.id);

  //   return match;
  // };

  const onCompanySelected = (row) => {
    const { original } = row;
    setSelectedCompany(original);
    setPickCompaniesOpen(false);
    setKivraOpen(true);
  };

  const kivraSettings = useSelector(
    (state) => state.billectaIntegrations.kivraSettings
  );

  const companyColumns = React.useMemo(
    () =>
      companyListDefs(
        hasBillectaViewPermission,
        kivraSettings,
        integrationName
      ),
    [withCompanyInvoicingQuery, hasBillectaViewPermission, kivraSettings]
  );

  React.useEffect(() => {
    if (companies != null && !companiesLoading) {
      dispatch(
        bulkGetIntegrationSettings({
          companies,
          integrationSetting: "kivraSettings",
        })
      );
    }
  }, [companiesLoading]);

  const renderLogo = () => {
    return (
      <div
        style={{
          height: 50,
          width: 70,
          marginRight: 8,
          boxShadow: "0px 2px 11px -1px rgba(0, 0, 0, 0.2)",
          borderRadius: 8,
          backgroundSize: "60%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${current.image})`,
        }}
      ></div>
    );
  };

  const renderInfoPills = () => (
    <OverviewSubtitle>{current.description}</OverviewSubtitle>
  );

  return (
    <>
      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Integration ${current.title}`}
          {...{
            renderLogo,
            renderInfoPills,
            breadCrumbs: [
              { url: "/configcenter/integrations", label: "Integrationer" },
              { label: current?.title },
            ],
          }}
          config={true}
        />
        <DetailInnerWrapper>
          <DetailPageBoxFlexWrapper config={true}>
            <DetailPageBox
              style={{ flex: 1, width: "100%", alignSelf: "flex-start" }}
            >
              <OverviewTitleWrapper>
                <OverviewTitleWithSubtitleWrapper>
                  <OverviewTitle>Integrationsinformation</OverviewTitle>
                  <OverviewSubtitle>
                    <TextButton
                      title="Besök Kivras hemsida"
                      iconType="launch"
                      iconPlacement="right"
                      clicked={goToWebsite}
                    />
                  </OverviewSubtitle>
                </OverviewTitleWithSubtitleWrapper>
              </OverviewTitleWrapper>

              <InnerBox>
                <OverviewTitleWrapper>
                  <OverviewTitleWithSubtitleWrapper>
                    <OverviewTitle small>
                      Hur fungerar integrationen?
                    </OverviewTitle>
                  </OverviewTitleWithSubtitleWrapper>
                </OverviewTitleWrapper>
                <BodyText>
                  Kivra-integrationen gör det möjligt att skicka fakturor direkt
                  till mottagarens Kivra-brevlåda.
                  <br />
                  <br />
                  Integrationen aktiveras under bolagsinställningarna på
                  respektive bolag
                </BodyText>
              </InnerBox>
            </DetailPageBox>
            <IntegrationCompaniesWrapper>
              <DetailPageBox
                style={{ flex: 1, marginRight: "5px", alignSelf: "flex-start" }}
              >
                <OverviewTitleWrapper>
                  <OverviewTitleWithSubtitleWrapper>
                    <OverviewTitle small>Hantera integration</OverviewTitle>
                    <OverviewSubtitle>
                      Välj vilket bolag integrationen ska hanteras för
                    </OverviewSubtitle>
                  </OverviewTitleWithSubtitleWrapper>
                  <PrimaryButton
                    extraStyle={{ width: "30%", alignSelf: "end" }}
                    newDesign
                    clicked={() => setPickCompaniesOpen(true)}
                    title="Hantera"
                  />
                </OverviewTitleWrapper>

                {/* Always visible, displays companies with integration status */}
                <CompanyTable
                  {...{
                    persistantQuery: withCompanyInvoicingQuery,
                    isBare: true,
                    ignoreLocalStorage: true,
                    integrationSettings: kivraSettings,
                    integrationName: integrationName,
                  }}
                />
              </DetailPageBox>
            </IntegrationCompaniesWrapper>
          </DetailPageBoxFlexWrapper>
        </DetailInnerWrapper>
        {/* Opens on clicking "Hantera" on Company Table, pick company to manage integration */}
        <StandardModal
          isOpen={pickCompaniesOpen}
          closeFunction={() => setPickCompaniesOpen(false)}
          withActionBar
          title="Hantera integration för Bolag"
        >
          {addCompaniesLoading && <OverlaySpinner />}
          <BaseTable
            constants={companyConstants}
            columns={companyColumns}
            persistantQuery={withCompanyInvoicingQuery}
            {...{
              onRowClicked: onCompanySelected,
            }}
          />
        </StandardModal>
        {/* Opens on selecting a company in StandardModal above, displays Kivra form to activate for selected company  */}
        <KivraIntegrationForm
          open={kivraOpen}
          closeFunction={() => setKivraOpen(false)}
          companies={companies}
          currentCompany={selectedCompany}
        />
      </DetailLayoutWrapper>
    </>
  );
}
